import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`
const MenuContainer = styled.div`
  position: relative;
  padding-top: 20px;
`
const MediumIcon = styled.i`
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0px 15px;
  border-radius: 10px;
  ${props => props.isOpen ? 'background: #979797;' : ''};
  &:hover {
    ${props => !props.isOpen ? 'background: #d4d4d4;' : ''}
  }
`
const Menu = styled.div`
  display: ${props => props.isOpen ? 'block' : 'none'};
  border: 1px solid #b3b3b3;
  border-radius: 5px;
  position: absolute;
  background: white;
  right: 10px;
  font-size: 16px;
`
const MenuItem = styled.div`
  cursor: pointer;
  white-space: nowrap;
  font-size: 16px;
  line-height: 22px;
  &:first-of-type {
    padding: 10px 20px 20px 20px;
  }
  &:last-of-type {
    padding: 0px 20px 10px 20px;
  }
`
const Title = styled.div`
  font-family: 'Zilla Slab', serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 42px;
  margin: 0px;
  padding: 20px 0px 0px 40px;
`

class PodCardHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMenuOpen: false
    }
  }
  static propTypes = {
    name:              PropTypes.string.isRequired,
    onDeleteModalOpen: PropTypes.func.isRequired,
    onEditClick:       PropTypes.func.isRequired
  }
  onMenuToggle = () => {
    const isMenuOpen = !this.state.isMenuOpen
    this.setState({ isMenuOpen })
    if (isMenuOpen) {
      document.addEventListener('click', this.onDocumentClick)
    } else {
      document.removeEventListener('click', this.onDocumentClick)
    }
  }
  onDeleteClick = () => {
    this.props.onDeleteModalOpen()
    this.onMenuToggle()
  }
  onEditClick = () => {
    this.onMenuToggle()
    this.props.onEditClick()
  }
  onDocumentClick = () => {
    this.onMenuToggle()
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.onDocumentClick)
  }
  render() {
    const { name } = this.props
    const { isMenuOpen } = this.state
    return (
      <CardHeader>
        <div>
          <Title>{name}</Title>
        </div>
        <MenuContainer>
          <MediumIcon onClick={this.onMenuToggle} isOpen={isMenuOpen} className='fa fa-ellipsis-h' />
          <Menu isOpen={isMenuOpen}>
            <MenuItem onClick={this.onEditClick}>
                Edit Pod
            </MenuItem>
            <MenuItem onClick={this.onDeleteClick}>
                Delete Pod
            </MenuItem>
          </Menu>
        </MenuContainer>
      </CardHeader>
    )
  }
}

export default PodCardHeader
